import { PolicyValidationResult } from '@policyvision/contracts';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ValidationProvider } from '@/policy/contexts';
import { PolicyExtractedData } from '@/policy/types/PolicyCoverage';

import { PolicyDetailPageContent } from './PolicyDetailPageContent';

interface PolicyDetailPageBodyProps {
  isPolicyLoading: boolean;
  isPdfLoading: boolean;
  policy: PolicyExtractedData | undefined;
  pdfBlob: Blob | undefined;
  policyUuid: string;
  initialValidations: PolicyValidationResult;
}

export const PolicyDetailPageBody = ({
  isPolicyLoading,
  isPdfLoading,
  policy,
  pdfBlob,
  policyUuid,
  initialValidations,
}: PolicyDetailPageBodyProps) => {
  const { t } = useTranslation();

  if (isPolicyLoading || isPdfLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <Loader2 className="size-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!pdfBlob || !policy) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-gray-600">{t('policy.noPdfAvailable')}</p>
      </div>
    );
  }

  return (
    <ValidationProvider
      key={policyUuid}
      initialValidations={initialValidations}
    >
      <PolicyDetailPageContent
        uuid={policyUuid}
        policy={policy}
        pdfBlob={pdfBlob}
      />
    </ValidationProvider>
  );
};
